import { createAsyncThunk } from '@reduxjs/toolkit';
import { isAxiosError } from 'axios';

import { buildApiUrl } from '../../utils/axiosClient';
import { PerformanceIndicators } from './slice';
import { loadLatestPerformanceIndicatorsReport } from 'services/reports';

export const getLatestReport = createAsyncThunk(
  'performanceIndicators/getLatestReport',
  async (): Promise<PerformanceIndicators> => {
    try {
      const settings = await loadLatestPerformanceIndicatorsReport();
      return settings || {};
    } catch (error) {
      if (isAxiosError(error)) {
        if (error.response && error.response?.status === 403) {
          return new Promise((resolve, reject) => {
            window.location.replace(buildApiUrl(process.env.REACT_APP_LOGIN_PAGE ?? ''));
          });
        }
      }
      throw error;
    }
  },
);
